export const FooterTitles = {
    english: {
        title: "UN Free & Equal is an initiative of the United Nations Human Rights Office.",
        copyright: "© OHCHR",
        logoUrl: "https://www.standup4humanrights.org/en/",
        humanRightsUrl: "https://www.ohchr.org/en/ohchr_homepage"
    },
    russian: {
        title: `Кампания ООН "Свободные и равные" – это инициатива Управления ООН по правам человека.`,
        copyright: "© УВКПЧ",
        logoUrl: "https://www.standup4humanrights.org/ru/",
        humanRightsUrl: "https://www.ohchr.org/ru/ohchr_home"
    },
    chinese: {
        title: "联合国自由与平等是联合国人权办公室的一项倡议",
        copyright: "© 人权高专办",
        logoUrl: "https://www.standup4humanrights.org/zh/",
        humanRightsUrl: "https://www.ohchr.org/zh/ohchr_home"
    },
    arabic: {
        title: "أحرار ومتساوون هي مبادرة أطلقتها مفوضية الأمم المتحدة لحقوق الإنسان",
        copyright: "© مفوّضية الأمم المتحدة السامية لحقوق الإنسان",
        logoUrl: "https://www.standup4humanrights.org/ar/",
        humanRightsUrl: "https://www.ohchr.org/ar/ohchr_home"
    },
    french: {
        title: "Libres et Égaux Nations Unies est une initiative du Haut-Commissariat des Nations Unies aux droits de l'homme.",
        copyright: "© HCDH",
        logoUrl: "https://www.standup4humanrights.org/fr/",
        humanRightsUrl: "https://www.ohchr.org/fr/ohchr_home"
    },
    portuguese: {
        title: "A ONU Livres & Iguais é uma iniciativa do Escritório de Direitos Humanos das Nações Unidas.",
        copyright: "© ACNUDH",
        logoUrl: "https://www.standup4humanrights.org/en/",
        humanRightsUrl: "https://www.ohchr.org/en/ohchr_homepage"
    },
    spanish: {
        title: "Libres e Iguales de las Naciones Unidas es una iniciativa de la Oficina de Derechos Humanos de las Naciones Unidas.",
        copyright: "© ACNUDH",
        logoUrl: "https://www.standup4humanrights.org/es/",
        humanRightsUrl: "https://www.ohchr.org/es/ohchr_home"
    }
};

exports = {
    FooterTitles
};